import { render, staticRenderFns } from "./form-edit.vue?vue&type=template&id=cc1472c0&scoped=true"
import script from "./form-edit.vue?vue&type=script&lang=js"
export * from "./form-edit.vue?vue&type=script&lang=js"
import style0 from "./form-edit.vue?vue&type=style&index=0&id=cc1472c0&prod&lang=css"
import style1 from "./form-edit.vue?vue&type=style&index=1&id=cc1472c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1472c0",
  null
  
)

export default component.exports